<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="exsbpriceitem_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="exsbpriceitem_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="exsbpriceitem_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="exsbpriceitem_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="exsbpriceitem_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="exsbpriceitem_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="exsbpriceitem_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_state"
        class="form-control-label">state</label>
      <input
        id="exsbpriceitem_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_name"
        class="form-control-label">name</label>
      <input
        id="exsbpriceitem_name"
        v-model="item.name"
        :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('name', $event.target.value)">
      <div
        v-if="isInvalid('name')"
        class="invalid-feedback">{{ violations.name }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_priceList"
        class="form-control-label">priceList</label>
      <input
        id="exsbpriceitem_priceList"
        v-model="item.priceList"
        :class="['form-control', isInvalid('priceList') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('priceList', $event.target.value)">
      <div
        v-if="isInvalid('priceList')"
        class="invalid-feedback">{{ violations.priceList }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_profit"
        class="form-control-label">profit</label>
      <input
        id="exsbpriceitem_profit"
        v-model="item.profit"
        :class="['form-control', isInvalid('profit') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('profit', $event.target.value)">
      <div
        v-if="isInvalid('profit')"
        class="invalid-feedback">{{ violations.profit }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_basic"
        class="form-control-label">basic</label>
      <input
        id="exsbpriceitem_basic"
        v-model="item.basic"
        :class="['form-control', isInvalid('basic') ? 'is-invalid' : '']"
        type="checkbox"
        placeholder=""
        @input="handleUpdateField('basic', $event.target.value)">
      <div
        v-if="isInvalid('basic')"
        class="invalid-feedback">{{ violations.basic }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_netto"
        class="form-control-label">netto</label>
      <input
        id="exsbpriceitem_netto"
        v-model="item.netto"
        :class="['form-control', isInvalid('netto') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('netto', $event.target.value)">
      <div
        v-if="isInvalid('netto')"
        class="invalid-feedback">{{ violations.netto }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_margin"
        class="form-control-label">margin</label>
      <input
        id="exsbpriceitem_margin"
        v-model="item.margin"
        :class="['form-control', isInvalid('margin') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('margin', $event.target.value)">
      <div
        v-if="isInvalid('margin')"
        class="invalid-feedback">{{ violations.margin }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_coating"
        class="form-control-label">coating</label>
      <input
        id="exsbpriceitem_coating"
        v-model="item.coating"
        :class="['form-control', isInvalid('coating') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('coating', $event.target.value)">
      <div
        v-if="isInvalid('coating')"
        class="invalid-feedback">{{ violations.coating }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_brutto"
        class="form-control-label">brutto</label>
      <input
        id="exsbpriceitem_brutto"
        v-model="item.brutto"
        :class="['form-control', isInvalid('brutto') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('brutto', $event.target.value)">
      <div
        v-if="isInvalid('brutto')"
        class="invalid-feedback">{{ violations.brutto }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpriceitem_item"
        class="form-control-label">item</label>
      <input
        id="exsbpriceitem_item"
        v-model="item.item"
        :class="['form-control', isInvalid('item') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('item', $event.target.value)">
      <div
        v-if="isInvalid('item')"
        class="invalid-feedback">{{ violations.item }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
